import { render } from "./Unsubscription.vue?vue&type=template&id=0c064c64&scoped=true"
import script from "./Unsubscription.vue?vue&type=script&lang=js"
export * from "./Unsubscription.vue?vue&type=script&lang=js"

import "./Unsubscription.vue?vue&type=style&index=0&id=0c064c64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c064c64"]])

export default __exports__